import { useCallback, useState } from 'react';

type UseClickSwapProps = {
  onSwap: (sourceSeq: number, targetSeq: number) => void;
};

type UseClickSwapReturn = {
  selectedCell: number | null;
  handleCellSelect: (seq: number) => void;
  clearSelection: () => void;
};

export const useClickSwap = ({
  onSwap
}: UseClickSwapProps): UseClickSwapReturn => {
  const [selectedCell, setSelectedCell] = useState<number | null>(null);

  const clearSelection = useCallback(() => {
    setSelectedCell(null);
  }, []);

  const handleCellSelect = useCallback(
    (seq: number) => {
      if (selectedCell === null) {
        setSelectedCell(seq);
        return;
      }

      if (selectedCell === seq) {
        setSelectedCell(null);
        return;
      }

      onSwap(selectedCell, seq);
      setSelectedCell(null);
    },
    [selectedCell, onSwap]
  );

  return { selectedCell, handleCellSelect, clearSelection };
};
